import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import { Controller } from "react-hook-form";
import { Suspense, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

export default function BuyVehicleView({
  goBack,
  isPJEnabled,
  onChangeSelect,
  isDisabled,
  types,
  brands,
  models,
  errorPlate,
  isLoading,
  error,
  handlePlate,
  errorCreateVehicle,
  success,
  register,
  handleSubmit,
  errors,
  isVisibleModal,
  toggleModal,
  control,
  isVisibleBulkModal,
  toggleBulkModal,
  selectedFile,
  onFileChange,
  isBulkLoading,
  bulkProgress,
  bulkResult,
  onBulkSubmit,
  onBulkReset,
}: PropsView) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  return (
    <div className="h-full">
      <Header
        title="Dados do veículo"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={handleSubmit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Dados do novo veículo</h2>
            <div className="flex flex-col justify-center">
              <InputMask 
                {...register("plate")}
                name="plate" 
                placeholder="Sua Placa" 
                className="uppercase mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14" 
                mask="___-.@.." 
                replacement={{ _: /\D/, ".": /\d/, "@": /[A-Za-z0-9]*/ }} 
                type="text"
              />
              {errors.plate && (
                <span className="text-red-500 text-xs">{errors.plate.message as string}</span>
              )}
              <Controller 
                control={control}
                name="type"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Tipo do veículo" 
                    name="type" 
                    className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14">
                      <option value="0">Tipo do veículo</option>
                      {types?.map((item, index) => (
                        <option key={index} value={item.id}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.type && (
                <span className="text-red-500 text-xs">{errors.type.message as string}</span>
              )}
              <Controller 
                control={control}
                name="brand"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Marca" 
                    name="brand" 
                    className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14">
                      <option value="0">Marca</option>
                      {brands?.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.brand && (
                <span className="text-red-500 text-xs">{errors.brand.message as string}</span>
              )}
              <Controller 
                control={control}
                name="model"
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <select 
                    onChange={e => onChangeSelect({
                      e,
                      onChange,
                    })} 
                    value={value} 
                    title="Modelo" 
                    name="model" 
                    className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14">
                      <option value="0">Modelo</option>
                      {models?.map((item, index) => (
                        <option key={index} value={item.value}>{item.text}</option>
                      ))}
                  </select>
                )}
              />
              {errors.model && (
                <span className="text-red-500 text-xs">{errors.model.message as string}</span>
              )}
            </div>
          </div>
          <div className="flex flex-col gap-3 pb-2">
            <Button 
              className="rounded-xl bg-primary text-white"
              title="Continuar"
              type="submit"
              isDisabled={isDisabled}
            />
            {isPJEnabled && (
              <button
                type="button"
                onClick={toggleBulkModal}
                className="text-black text-base font-medium text-center py-2"
              >
                Mais veículos
              </button>
            )}
          </div>
        </form>
      </main>
      {error && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Houve um problema ao validar sua placa, quer tentar novamente?"
          actionMessage="Tentar novamente"
          action={() => {
            handlePlate();
            toggleModal();
          }}
          actionSecondMessage="Não!"
          actionSecond={toggleModal}
        />
      </Suspense>}
      {errorPlate && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Atenção!"
          message="Esta placa é inválida."
          actionMessage="Entendi"
          action={toggleModal}
          actionSecond={toggleModal}
        />
      </Suspense>}
      {errorCreateVehicle && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Houve um problema ao incluir o veículo, quer tentar novamente?"
          actionMessage="Sim"
          action={() => {
            handleSubmit();
            toggleModal();
          }}
          actionSecondMessage="Não"
          actionSecond={toggleModal}
        />
      </Suspense>}
      {success && isVisibleModal && <Suspense fallback={null}>
        <Modal
          title="Muito bem!"
          message="Veículo adicionado com sucesso ao cadastro."
          actionMessage="Atualizar"
          action={() => {
            const newVehicle = customer?.vehicles?.[customer.vehicles.length - 1];
            if (newVehicle?.plate) {
              dispatch(setCustomer({ 
                selectedVehicles: [newVehicle.plate]
              }));
            }
            goBack();
            toggleModal();
          }}
        />
      </Suspense>}
      {isLoading && <Loading />}
      {isPJEnabled && isVisibleBulkModal && <Suspense fallback={null}>
        <Modal
          content={
            <div className="flex flex-col">
              <div className="absolute top-3 left-1/2 transform -translate-x-1/2 w-10 h-1 bg-gray-300 rounded-full" />
              {!isBulkLoading && (
                <button
                  type="button"
                  onClick={bulkResult ? onBulkReset : toggleBulkModal}
                  className="absolute top-6 right-6 text-black"
                >
                  <img src="/svg/icon-close.svg" alt="Fechar" className="w-6 h-6" />
                </button>
              )}

              {isBulkLoading ? (
                <div className="mt-6 mb-2">
                  <p className="text-black text-xl font-bold text-center mb-8">Processando...</p>
                  <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                    <div
                      className="bg-green-500 h-2 rounded-full transition-all duration-300 ease-in-out"
                      style={{ width: `${bulkProgress}%` }}
                    />
                  </div>
                  <div className="flex justify-between mt-1">
                    <span className="text-black text-sm font-bold truncate max-w-[60%]">{selectedFile?.name}</span>
                    <span className="text-black text-sm">{bulkProgress}% carregando</span>
                  </div>
                </div>
              ) : bulkResult ? (
                <div className="mt-6 mb-2">
                  <p className="text-black text-xl font-bold text-center mb-4">
                    {bulkResult.code === 1 ? 'Sucesso!' : 'Atenção!'}
                  </p>
                  <p className="text-black text-sm mb-4 text-center">
                    {bulkResult.message || (bulkResult.code === 1
                      ? 'Todas as placas foram cadastradas com sucesso.'
                      : 'Houve um problema ao processar as placas.')}
                  </p>
                  {bulkResult.errors?.length > 0 && (
                    <div className="max-h-40 overflow-y-auto mb-4 border border-gray-100 rounded-xl p-3 space-y-2">
                      {bulkResult.errors.map((err, i) => (
                        <div key={i} className="text-xs text-red-600">
                          Linha {err.line}: Placa <strong>{err.plate}</strong> — {err.reason}
                        </div>
                      ))}
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={() => { onBulkReset(); toggleBulkModal(); }}
                    className="w-full bg-black text-white rounded-xl py-4 text-base font-medium mt-2"
                  >
                    Fechar
                  </button>
                </div>
              ) : (
                <>
                  <p className="text-black text-xl font-bold text-center mt-6 mb-5">Anexar</p>
                  <div className="text-black text-sm mb-5 space-y-3">
                    <p className="font-bold">Orientações para importação da planilha:</p>
                    <p>
                      Coluna A: <strong>Placa</strong> - Deve conter de 5 a 7 posições contendo apenas letras e números. Não utilize caracteres especiais (!@#$%¨&amp;*()_{}?/;,-)
                    </p>
                    <p>Você poderá fazer o upload de até 20 placas a cada arquivo.</p>
                    <p>
                      Baixe a planilha{" "}
                      <a href="/Cadastro Massivo de Placas.xlsx" download className="underline font-semibold">
                        clicando aqui
                      </a>
                      , preencha os dados e faça upload através do botão abaixo.
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => fileInputRef.current?.click()}
                    className="w-full bg-gray-100 border border-dashed border-gray-400 rounded-xl flex flex-col items-center justify-center gap-2 py-6 mb-5"
                  >
                    {selectedFile ? (
                      <span className="text-black text-sm font-semibold px-2 text-center break-all">{selectedFile.name}</span>
                    ) : (
                      <>
                        <span className="w-8 h-8 rounded-full border-2 border-black flex items-center justify-center text-black text-xl font-light">+</span>
                        <span className="text-gray-500 text-sm">
                          Arraste ou{" "}
                          <span className="underline font-semibold text-black">clique aqui</span>
                          {" "}para enviar
                        </span>
                      </>
                    )}
                  </button>
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept=".xls,.xlsx"
                    className="hidden"
                    onChange={e => {
                      onFileChange(e.target.files?.[0] ?? null);
                      e.target.value = '';
                    }}
                  />
                  <button
                    type="button"
                    onClick={onBulkSubmit}
                    disabled={!selectedFile}
                    className="w-full bg-black text-white rounded-xl py-4 text-base font-medium disabled:opacity-40"
                  >
                    Atualizar
                  </button>
                </>
              )}
            </div>
          }
        />
      </Suspense>}
    </div>
  );
}
